<h1 mat-dialog-title class="cancel-text">{{'ongoingTask.cancelDialogTitle' | translate}}</h1>
<mat-dialog-content>
    <p [innerHTML]="data.message"></p>

    <div class="confirmation-section">
        <mat-form-field appearance="outline" class="confirmation-field">
            <input
                    matInput
                    [formControl]="confirmationInput"
                    class="confirmation-input"
                    placeholder="{{'ongoingTask.confirmationPlaceholder' | translate}}">
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="onCancel()" cdkFocusInitial>
        {{'ongoingTask.cancelBtn' | translate}}
    </button>
    <button
            mat-button
            color="primary"
            [disabled]="!isConfirmEnabled()"
            (click)="onConfirm()">
        {{'ongoingTask.confirmBtn' | translate}}
    </button>
</mat-dialog-actions>
